(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-drawer-open');
      var drawer = document.getElementById(id);
      if (drawer) drawer.classList.add('is-open');
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = btn.closest('.cf-drawer');
      if (drawer) drawer.classList.remove('is-open');
    });
  });

  document.querySelectorAll('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var modal = document.getElementById('CfSearchModal');
      if (modal) {
        modal.classList.add('is-open');
        var input = modal.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      }
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var modal = document.getElementById('CfSearchModal');
      if (modal) modal.classList.remove('is-open');
    });
  });

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-gallery-thumb');
        if (main && src) {
          main.src = src;
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        }
      });
    });
  });

  document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.classList.toggle('is-active');
      if (btn.classList.contains('is-active')) {
        btn.style.color = 'var(--cf-sale)';
      } else {
        btn.style.color = '';
      }
    });
  });

  document.querySelectorAll('[data-share]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (navigator.share) {
        navigator.share({ title: document.title, url: window.location.href }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href);
      }
    });
  });

  function parseMoneyNumber(raw) {
    if (!raw) return 0;
    var n = String(raw).replace(/[^\d.]/g, '');
    return Number(n) || 0;
  }

  document.querySelectorAll('[data-cod-form]').forEach(function (form) {
    var offers = form.querySelectorAll('[data-offer]');
    var qtyInput = form.querySelector('[name="quantity"], [data-cod-qty]');

    offers.forEach(function (offer) {
      offer.addEventListener('click', function () {
        offers.forEach(function (o) { o.classList.remove('is-selected'); });
        offer.classList.add('is-selected');
        var qty = offer.getAttribute('data-qty');
        if (qtyInput && qty) qtyInput.value = qty;
        var stickyPrice = document.querySelector('[data-sticky-price]');
        var price = offer.getAttribute('data-price-label');
        if (stickyPrice && price) stickyPrice.textContent = price;
      });
    });

    form.addEventListener('submit', function (e) {
      var bridge = form.getAttribute('data-codform-bridge') === 'true';
      var nameEl = form.querySelector('[data-cod-name]');
      var phoneEl = form.querySelector('[data-cod-phone]');
      var err = form.querySelector('[data-cod-error]');
      var name = nameEl ? nameEl.value.trim() : '';
      var phone = phoneEl ? phoneEl.value.trim() : '';

      if (!name || !phone) {
        e.preventDefault();
        if (err) {
          err.textContent = 'يرجى إدخال الاسم ورقم الجوال';
          err.hidden = false;
        }
        return;
      }

      if (!bridge) {
        var btnNative = form.querySelector('[type="submit"]');
        if (btnNative) {
          btnNative.disabled = true;
          btnNative.innerHTML = '<span>جارٍ إرسال الطلب...</span>';
        }
        return;
      }

      e.preventDefault();

      var api = form.getAttribute('data-codform-api');
      var key = form.getAttribute('data-codform-key');
      var storeId = form.getAttribute('data-codform-store-id');
      var productId = form.getAttribute('data-codform-product-id');
      var productName = form.getAttribute('data-codform-product-name') || 'Product';
      var unitPrice = parseMoneyNumber(form.getAttribute('data-codform-unit-price'));
      var thankYou = form.getAttribute('data-codform-thank-you') || '';
      var qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1);
      var cityEl = form.querySelector('[data-cod-city]');
      var addressEl = form.querySelector('[data-cod-address]');
      var total = Math.round(unitPrice * qty * 100) / 100;

      if (!api || !key || !storeId || !productId) {
        if (err) {
          err.textContent = 'إعدادات ربط Codform غير مكتملة';
          err.hidden = false;
        }
        return;
      }

      var btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = '<span>جارٍ إرسال الطلب...</span>';
      }
      if (err) err.hidden = true;

      var payload = {
        store_id: storeId,
        customer_name: name,
        customer_phone: phone,
        city: cityEl ? cityEl.value.trim() || null : null,
        address: addressEl ? addressEl.value.trim() || null : null,
        payment_method: 'cod',
        shipping_method: 'standard',
        subtotal: total,
        shipping_cost: 0,
        total: total,
        items: [{
          product_id: productId,
          product_name: productName,
          quantity: qty,
          unit_price: unitPrice,
          total_price: total
        }],
        notes: 'Shopify:' + (window.location.hostname || '')
      };

      fetch(api, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': key,
          'Authorization': 'Bearer ' + key
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok || !result.data || !result.data.success || !result.data.order_id) {
            var msg = (result.data && (result.data.error || result.data.message)) || 'فشل إرسال الطلب';
            if (err) {
              err.textContent = msg;
              err.hidden = false;
            }
            if (btn) {
              btn.disabled = false;
              btn.innerHTML = '<span>اضغط لتأكيد الطلب</span>';
            }
            return;
          }

          var orderId = result.data.order_id;
          var base = thankYou || ('/pages/thank-you');
          var sep = base.indexOf('?') >= 0 ? '&' : '?';
          window.location.href = base + sep + 'order=' + encodeURIComponent(orderId) + '&total=' + encodeURIComponent(String(total));
        })
        .catch(function () {
          if (err) {
            err.textContent = 'تعذر الاتصال بخادم الطلبات. حاول مرة أخرى.';
            err.hidden = false;
          }
          if (btn) {
            btn.disabled = false;
            btn.innerHTML = '<span>اضغط لتأكيد الطلب</span>';
          }
        });
    });
  });

  document.querySelectorAll('[data-scroll-to-form]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var el = document.getElementById('order-form-section');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
